export default __webpack_public_path__ + "bd3835f0b6a63eeb6bab1e51a6e9c9bb.png";